interface IErrorDetails {
  message: string,
  request: any,
  response?: any
}

/**
 * Returns a string with details of an error.
 */
export const getErrorDetails = (error: any): string => {
  const { response, request } = error;

  if (!response && !request) {
    return error;
  }

  const { config, message } = error;

  const {
    url,
    method,
    timeout,
    headers: requestHeaders,
    data: requestData,
  } = config;

  const errorDetails: IErrorDetails = {
    message,
    request: {
      url,
      method,
      timeout,
      data: requestData,
      headers: requestHeaders,
    },
  };

  if (response) {
    const { data, status, headers } = response;
    errorDetails.response = {
      status,
      data,
      headers,
    };
  }

  return JSON.stringify(errorDetails);
};
